import { render, staticRenderFns } from "./inventory-report-drawer.vue?vue&type=template&id=bae0b2fa&scoped=true&"
import script from "./inventory-report-drawer.vue?vue&type=script&lang=js&"
export * from "./inventory-report-drawer.vue?vue&type=script&lang=js&"
import style0 from "./inventory-report-drawer.vue?vue&type=style&index=0&id=bae0b2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae0b2fa",
  null
  
)

export default component.exports